import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./index.css"
import "@relex-solutions/fragments/fonts/source-sans-3/source-sans-3VF.css"
import "@relex-solutions/fragments/fonts/source-code-pro/source-code-variable.css"
import { App } from "./App"

const root = document.getElementById("root")

if (!root) {
  document.body.innerHTML = `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      font-family: system-ui, -apple-system, sans-serif;
      padding: 2rem;
      text-align: center;
    ">
      <h1 style="color: #d32f2f; margin-bottom: 1rem;">❌ Application Error</h1>
      <p style="color: #666; max-width: 600px;">
        Root element not found. The application failed to initialize.
        Check the browser console for more details.
      </p>
    </div>
  `
  throw new Error("Root element #root not found in DOM")
}

try {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
} catch (error) {
  // biome-ignore lint/suspicious/noConsole: Critical initialization error needs console logging
  console.error("🚨 Failed to render React app:", error)
  root.innerHTML = `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      font-family: system-ui, -apple-system, sans-serif;
      padding: 2rem;
      text-align: center;
    ">
      <h1 style="color: #d32f2f; margin-bottom: 1rem;">❌ Application Error</h1>
      <p style="color: #666; max-width: 600px; margin-bottom: 1rem;">
        Failed to initialize the application. Please check the browser console for details.
      </p>
      <details style="max-width: 600px; text-align: left; background: #f5f5f5; padding: 1rem; border-radius: 4px;">
        <summary style="cursor: pointer; font-weight: bold; margin-bottom: 0.5rem;">Error Details</summary>
        <pre style="overflow: auto; font-size: 0.875rem;">${error instanceof Error ? error.message : String(error)}</pre>
      </details>
      <button 
        onclick="window.location.reload()" 
        style="
          margin-top: 1rem;
          padding: 0.75rem 1.5rem;
          background: #1976d2;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
        "
      >
        Reload Application
      </button>
    </div>
  `
}
